import React, { useMemo } from 'react';
import { 
    Dialog, 
    DialogActions, 
    DialogContentText, 
    DialogContent,
    DialogTitle,
    Button,
    useMediaQuery,
} from "@mui/material";
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import LoadingButton from '@mui/lab/LoadingButton';
import { useTheme } from '@mui/material/styles';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

import Constant from '../../util/constants';

const { label } = Constant;

function MuiDialog({ open, onClose, title, children, actionContent, onOk, onReset, loading, actions, ...props }){
    const { scroll } = props;
    const theme = useTheme();
    const belowSmScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const styles = useMemo(() => ({
        dialogAction: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'center',
        },
        closeIcon: {
            position: 'absolute',
            top: 10,
            right: 10
        },
        okButton: {
           '&:hover': {
               backgroundColor: 'var(--app-color)'
           }
        }
    }), [belowSmScreen])

    const actionsContent = useMemo(() => (<>
        <Button variant='outlined' color="error" fullWidth={belowSmScreen} onClick={onClose} sx={{ borderRadius: '8px' }}>{label.CANCEL}</Button>
        {onReset && (
            <Button variant='outlined' fullWidth={belowSmScreen} onClick={onReset} sx={{ borderRadius: '8px' }}>Clear Filters</Button>
        )}
        <LoadingButton variant='contained' loading={loading} sx={{ ...styles.okButton, borderRadius: '8px' }} fullWidth={belowSmScreen} onClick={onOk}>{label.APPLY_FILTER}</LoadingButton>
    </>), [onOk, onClose, onReset, belowSmScreen, loading]);

    return (
        <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby={`scroll-dialog-${title}`}
        aria-describedby="scroll-dialog-description"
        {...props}
        >
            {title !== '' && <DialogTitle id={`scroll-dialog-${title}`}>{title}</DialogTitle>}
            <DialogContent dividers={scroll === 'paper'}>
                <DialogContentText
                 id="scroll-dialog-description"
                 tabIndex={-1}
                >
                {children}
                <Tooltip title="Close" placement="bottom">
                <IconButton onClick={onClose} sx={styles.closeIcon} aria-label="close dialog">
                    <CloseOutlinedIcon />
                </IconButton>
                </Tooltip>
                </DialogContentText>
            </DialogContent>    
            {actions && 
            <DialogActions className={actionContent && 'MuiAction-root-custom'} sx={{ ...styles.dialogAction, gap: 1, px: 2, pb: 2, '& > :not(:first-of-type)': { m: 0 } }}>
                {!actionContent ? actionsContent : actionContent}
            </DialogActions>}
        </Dialog>
    )
}

MuiDialog.defaultProps = {
    scroll: 'paper',
    title: '',
    maxWidth: 'xs',
    actions: true,
    onOk: () => {}
  };

export default MuiDialog